import React, { Component } from "react";
import Slider from "react-slick";

import partners from "../../../../api/PartnersData";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./PartnersSection.css";

class PartnersSection extends Component {
  render() {
    var settings = {
      dots: false,
      arrows: true,
      speed: 1000,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    const ClickHandler = () => {
      window.scrollTo(10, 0);
    };

    return (
      <div className={`wpo-project-area ${this.props.pClass}`}>
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="wpo-project-wrap project-active owl-carousel">
              <Slider {...settings}>
                {partners.map((partner, pot) => (
                  <div className="wpo-project-item" key={pot}>
                    <div className="wpo-project-img" style={{ height: 200 }}>
                      <img
                        className={partner.class}
                        src={partner.pImg}
                        alt=""
                      />
                      <div className="left-border"></div>
                      <div className="right-border"></div>
                    </div>
                    <div className="wpo-project-text">
                      <h2>{partner.title}</h2>
                      <span>{partner.subTitle}</span>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PartnersSection;
